import { dateTimeDateToExcelDate, doRequest } from './util';
import { DateTime } from 'luxon';

/* global window */

export async function loadLivePrices(
  market_area_id: string,
  price_types: string[],
  exchanges: string[],
  product: string,
  headers: string,
  unit: string,
  currency: string
) {
  let url =
    window.api_url +
    '/prices/list?data_type_filter=' +
    encodeURIComponent('energy prices live');
  if (market_area_id !== '' && market_area_id !== 'null') {
    url += '&market_area_id=' + market_area_id;
  }
  if (
    price_types !== undefined &&
    price_types !== null &&
    price_types.length > 0
  ) {
    price_types.forEach((price_type) => {
      url += '&price_type=' + encodeURIComponent(price_type);
    });
  }
  if (exchanges !== undefined && exchanges !== null && exchanges.length > 0) {
    exchanges.forEach((exchange) => {
      url += '&exchange=' + encodeURIComponent(exchange);
    });
  }
  if (product !== '') {
    url += '&product=' + encodeURIComponent(product);
  }
  let response = await doRequest(url);
  if (!response.ok) {
    let error = await response.json();
    return [[response.statusText + ':' + error.message + '  ' + url]];
  }
  let json_response = await response.json();
  let ids: any[] = [];
  let prices_length = json_response.prices.length;
  for (let i = 0; i < prices_length; i++) {
    ids.push(json_response.prices[i].id);
  }
  if (ids.length > 0) {
    return loadLivePricesByIds(ids.join(','), headers, unit, currency);
  } else {
    return [['Error: no prices with given specification']];
  }
}

export async function loadLivePricesByIds(
  ids: string,
  headers: string,
  unit: string,
  currency: string
) {
  if (ids === 'undefined' || ids === '') {
    return [['ids must be given']];
  } else {
    try {
      let id_arr = ids.replace(/\s/g, '').split(',');
      let header_arr = headers.replace(/\s/g, '').split(',');
      let id_arr_length = id_arr.length;
      let url_ids = '';
      for (let i = 0; i < id_arr_length; i++) {
        if (i === 0) {
          url_ids += 'ids=' + id_arr[i];
        } else {
          url_ids += '&ids=' + id_arr[i];
        }
      }
      let url_params = '';
      if (unit !== undefined && unit !== null && unit !== '') {
        url_params += '&unit=' + encodeURIComponent(unit);
      }
      if (currency !== undefined && currency !== null && currency !== '') {
        url_params += '&currency=' + encodeURIComponent(currency);
      }
      const urls: any[] = [];
      while (url_ids.length + url_params.length >= 2000) {
        let url = url_ids.substring(0, 1500);
        let last_index = url.lastIndexOf('&');
        url = url.substring(0, last_index);
        urls.push(window.api_url + '/prices/live_data?' + url + url_params);
        url_ids = url_ids.substring(last_index + 1);
      }
      urls.push(window.api_url + '/prices/live_data?' + url_ids + url_params);
      const results: any[] = [];
      for (const url of urls) {
        results.push(await doRequest(url));
      }
      let json_objects: any[] = [];
      for (let i = 0; i < results.length; i++) {
        if (!results[i].ok) {
          let error_json = await results[i].json();
          throw new Error(
            results[i].statusText + ':' + error_json.message + ' ' + urls[i]
          );
        }
        json_objects.push(await results[i].json());
      }
      let live_prices = json_objects[0].live_prices;
      for (let i = 1; i < json_objects.length; i++) {
        if (json_objects[i] !== undefined) {
          json_objects[i].live_prices.forEach((live_price: any) => {
            live_prices.push(live_price);
          });
        }
      }
      live_prices = live_prices.filter(
        (price: { product_code: string | string[] }) => {
          return (
            (price.product_code.includes('FX ') &&
              price.product_code.includes(' EUR ')) ||
            !price.product_code.includes(' EUR ')
          );
        }
      );
      let retPrices: any[] = [];
      retPrices.push(header_arr);
      retPrices[0].unshift('name');
      retPrices[0].unshift('product_code');
      let prices_length = live_prices.length;
      let header_arr_count = header_arr.length;
      for (let i = 0; i < prices_length; i++) {
        let prices_arr: any[] = [];
        prices_arr.push(
          live_prices[i].product_code === undefined
            ? ''
            : live_prices[i].product_code
        );
        prices_arr.push(
          live_prices[i].name === undefined ? '' : live_prices[i].name
        );
        if (live_prices[i].meta !== undefined) {
          let keys = Object.keys(live_prices[i].meta);
          for (let j = 2; j < header_arr_count; j++) {
            let value = live_prices[i].meta[keys[keys.indexOf(header_arr[j])]];
            if (header_arr[j].includes('time') && value !== undefined) {
              let date = new Date(value.replace(' ', 'T'));
              value = +dateTimeDateToExcelDate(DateTime.fromJSDate(date));
            }
            if (value === undefined || value === null || value === 0) {
              value = '';
            }
            if (typeof value === typeof '') {
              value = value.replace('(', '');
              value = value.replace(')', '');
            }
            prices_arr.push(value);
          }
          retPrices.push(prices_arr);
        }
      }
      return retPrices;
    } catch (error: any) {
      return [[error.message]];
    }
  }
}
